module.exports = __webpack_public_path__ + "img/max-file-transfer.ae9140a1.svg";